export const removeSpecialChars = (str: string): string => {
  // Replace all non-alphanumeric characters and spaces with empty string and convert to lowercase
  return str.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
};
